/* eslint-disable @typescript-eslint/no-explicit-any */

const TronIcon = ({ props }: any) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M17.904 6.52211C17.1025 5.76469 15.9939 4.60804 15.0909 3.78773L15.0375 3.74945C14.9486 3.67638 14.8483 3.61908 14.7409 3.57992C12.5637 3.16429 2.43067 1.22562 2.23298 1.25023C2.17759 1.25817 2.12464 1.27873 2.07803 1.31039L2.02728 1.3514C1.96477 1.41637 1.9173 1.49486 1.88836 1.58109L1.875 1.61664V1.81078V1.84086C3.01573 5.09203 7.51987 15.7424 8.40681 18.2416C8.46024 18.4112 8.56176 18.7338 8.75143 18.7502H8.79418C8.89569 18.7502 9.32848 18.1651 9.32848 18.1651C9.32848 18.1651 17.0651 8.56195 17.8479 7.53929C17.9492 7.41332 18.0386 7.27783 18.115 7.13461C18.1345 7.02255 18.1253 6.90724 18.0883 6.7999C18.0514 6.69256 17.9878 6.59685 17.904 6.52211ZM11.3134 7.64047L14.6154 4.83773L16.5522 6.66429L11.3134 7.64047ZM10.0311 7.45726L4.34613 2.68851L13.5441 4.42484L10.0311 7.45726ZM10.544 8.70687L16.3625 7.74711L9.7105 15.9502L10.544 8.70687ZM3.57407 3.16429L9.55555 8.35961L8.68999 15.9557L3.57407 3.16429Z"
            fill="#FF060A"
        />
    </svg>
)
export default TronIcon
